import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import AssignTagForm from './AssignTagForm';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import { LinearProgress } from 'ra-ui-materialui';

const AssignTagStep = ({ fundInvestorTagContext, setShouldHideBackButton }) => {
  const [initialFormValues, setInitialFormValues] = useState({});
  const {
    id: tagId,
    name: tagName,
    mapFundInvestorSortedByFund: mapFundInvestors
  } = fundInvestorTagContext;

  /**
   * note: We need to prefix every key because react-final-form does not handle numeric keys.
   * >> e.g: "id-<key>"
   */
  useEffect(() => {
    if (!isEmpty(fundInvestorTagContext.mapFundInvestorSortedByFund)) {
      fundInvestorTagContext.mapFundInvestorSortedByFund.forEach(
        ([fundId, { _fundName, investors }]) => {
          investors
            .sort((a, b) =>
              a.investorName
                .toLowerCase()
                .localeCompare(b.investorName.toLowerCase())
            )
            .forEach(investor => {
              setInitialFormValues(prev => ({
                ...prev,
                [`id-${fundId}`]: {
                  ...prev[`id-${fundId}`],
                  [`id-${investor.investorId}`]: false
                }
              }));
            });
        }
      );
    }
  }, [fundInvestorTagContext.mapFundInvestorSortedByFund]);

  if (isEmpty(initialFormValues)) {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: '90%' }}>Funds</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <LinearProgress />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  } else {
    return (
      <AssignTagForm
        tagId={tagId}
        tagName={tagName}
        mapFundInvestors={mapFundInvestors}
        initialFormValues={initialFormValues}
        setShouldHideBackButton={setShouldHideBackButton}
      />
    );
  }
};

export default AssignTagStep;
